import axiosInstance from "../../../../helpers/axiosInstance";

export const getClientsOptionApi = (props) => onResponse =>  {

    try {
        axiosInstance.get(`/users/clients/get-clients-for-dropdown`)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
            
    } catch (error) {
        
    }
    
};
export const getClientsOptionApiFilter = (props) => onResponse =>  {

    try {
        axiosInstance.get(`/users/clients/get-clients-dropdown`)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
            
    } catch (error) {
        
    }
    
};


export const importPaymentFiles = (props) => onResponse =>  {

    try {
        axiosInstance.post("/payment/upload-835-files", props.data)
        .then((response) => {
            onResponse(response);
        })
        .catch((err) => {
            onResponse(err.response);
        });
            
    } catch (error) {
        
    }
};


